var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarnCoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 19,
    viewBox: "0 0 24 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17285 12.4152C6.17285 10.6659 10.1526 9.24666 15.0636 9.24666C19.9733 9.24666 23.9531 10.666 23.9531 12.4152V15.3275C23.9531 17.0768 19.9733 18.496 15.0636 18.496C10.1526 18.496 6.17285 17.0767 6.17285 15.3275C6.17285 14.3567 6.17285 13.386 6.17285 12.4152Z",
    fill: "#FFB53F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0636 9.24666C19.9733 9.24666 23.9531 10.666 23.9531 12.4152C23.9531 14.1658 19.9733 15.5838 15.0636 15.5838C10.1526 15.5838 6.17285 14.1659 6.17285 12.4152C6.1728 10.6659 10.1526 9.24666 15.0636 9.24666Z",
    fill: "#FBD558"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0636 10.7273C18.9698 10.7273 22.1357 11.484 22.1357 12.4152C22.1357 13.3478 18.9698 14.1031 15.0636 14.1031C11.1574 14.1031 7.99023 13.3477 7.99023 12.4152C7.99023 11.484 11.1574 10.7273 15.0636 10.7273Z",
    fill: "#FEAD2B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5632 16.725L11.3226 16.7263V18.2015C11.0622 18.1592 10.81 18.1115 10.5632 18.0597V16.725ZM21.5495 15.9437V17.4939C21.8236 17.3889 22.0772 17.2786 22.3103 17.1626V15.9424L21.5495 15.9437ZM13.3091 18.4333C13.56 18.4524 13.8136 18.466 14.0699 18.4756V17.0658L13.3091 17.0672V18.4333ZM7.81592 17.1626C8.04907 17.2786 8.30267 17.3889 8.5767 17.4939V15.9424L7.81592 15.9437V17.1626ZM16.0564 18.4756C16.314 18.466 16.5663 18.451 16.8158 18.4333V17.0672L16.0564 17.0658V18.4756ZM18.8037 18.2015C19.064 18.1592 19.3176 18.1115 19.5631 18.0597V16.7263L18.8037 16.725V18.2015Z",
    fill: "#FB8116"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.61016 15.9355V16.879H3.5523V17.5525H2.61016V18.496H1.93666V17.5525H0.993164V16.879H1.93666V15.9355H2.61016Z",
    fill: "#FEAD2B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8466 5.60226V6.54572H20.7901V7.2179H19.8466V8.16136H19.1731V7.2179H18.231V6.54572H19.1731V5.60226H19.8466Z",
    fill: "#FEAD2B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M3.0628 0V0.9435H4.00494V1.61564H3.0628V2.55914H2.38925V1.61564H1.4458V0.9435H2.38925V0H3.0628Z",
    fill: "#FEAD2B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.162979 10.7682C-0.712318 9.2521 2.02542 6.0331 6.27787 3.57896C10.5304 1.12346 14.686 0.362675 15.5613 1.87739C16.0467 2.71861 16.5321 3.55847 17.0174 4.39833C17.8927 5.91446 15.155 9.13346 10.9026 11.5876C6.6501 14.0431 2.4944 14.8052 1.6191 13.2891C1.13371 12.4493 0.64837 11.6081 0.162979 10.7682Z",
    fill: "#FFB53F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.27787 3.57896C10.5304 1.12346 14.686 0.362675 15.5613 1.87739C16.4366 3.39352 13.6989 6.61252 9.44643 9.06666C5.19534 11.5222 1.03828 12.2829 0.162979 10.7682C-0.712318 9.2521 2.02542 6.0331 6.27787 3.57896Z",
    fill: "#FBD558"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.01833 4.86056C10.401 2.90817 13.5218 1.97967 13.9881 2.78681C14.4543 3.59395 12.0888 5.83129 8.70625 7.78509C5.32361 9.73748 2.20413 10.666 1.73786 9.85884C1.2716 9.0517 3.63569 6.81431 7.01833 4.86056Z",
    fill: "#FEAD2B"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M9.3278 10.8473L10.0327 12.0675C9.80504 12.1875 9.57868 12.3021 9.35237 12.4111L8.6693 11.2277L9.3278 10.8473ZM3.35059 13.0015L3.96005 14.0567C4.21909 14.0417 4.49452 14.0104 4.78355 13.964L4.00913 12.6211L3.35059 13.0015ZM6.11968 12.3048L6.78774 13.4609C7.02634 13.3832 7.26901 13.2973 7.5158 13.2046L6.77818 11.9257L6.11968 12.3048ZM11.0484 9.85335L11.7533 11.0736C11.9701 10.9373 12.1828 10.7982 12.39 10.6578L11.7069 9.47568L11.0484 9.85335ZM15.9022 5.75357L15.2436 6.13532L16.0194 7.47693C16.2035 7.25062 16.3684 7.02698 16.5116 6.81018L15.9022 5.75357ZM13.2571 8.18456L13.9948 9.46345C14.1993 9.29709 14.3942 9.12941 14.581 8.9617L13.9143 7.80688L13.2571 8.18456Z",
    fill: "#FB8116"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarnCoin);
export default __webpack_public_path__ + "static/media/earn-coin.0fbc07e648bfa8be51bceafb0d2f9ad5.svg";
export { ForwardRef as ReactComponent };